import React from 'react';

const ACTIVITY_ICONS = {
  envelope_sent: { icon: 'ri-send-plane-line', color: 'info' },
  envelope_completed: { icon: 'ri-checkbox-circle-line', color: 'success' },
  envelope_created: { icon: 'ri-file-add-line', color: 'primary' },
  envelope_revoked: { icon: 'ri-close-circle-line', color: 'secondary' },
  envelope_declined: { icon: 'ri-thumb-down-line', color: 'danger' },
  user_invited: { icon: 'ri-user-add-line', color: 'primary' },
  signature_completed: { icon: 'ri-quill-pen-line', color: 'success' },
};

function resolveActivityMeta(type) {
  const key = String(type || '').toLowerCase();
  return ACTIVITY_ICONS[key] || { icon: 'ri-pulse-line', color: 'secondary' };
}

function formatEventLabel(type) {
  return String(type || 'Activity').replace(/_/g, ' ');
}

const TeamActivityTimeline = ({ items = [], formatPersonLabel, formatTargetLabel, formatDateTime }) => (
  <div className="team-activity-timeline">
    {items.map((item, index) => {
      const meta = resolveActivityMeta(item.type || item.event);
      const key = item.id || `${item.type}-${index}`;
      return (
        <div key={key} className="team-activity-timeline__item">
          <div className={`team-activity-timeline__icon bg-${meta.color}-subtle text-${meta.color}`}>
            <i className={meta.icon} aria-hidden="true" />
          </div>
          <div className="team-activity-timeline__body">
            <div className="team-activity-timeline__title text-capitalize">
              {formatEventLabel(item.type || item.event)}
            </div>
            {formatTargetLabel(item.target ?? item.target_name) ? (
              <div className="team-activity-timeline__target">
                {formatTargetLabel(item.target ?? item.target_name)}
              </div>
            ) : null}
            <div className="team-activity-timeline__meta">
              <span>{formatPersonLabel(item.actor_name ?? item.actor ?? item.user)}</span>
              <span className="team-activity-timeline__dot" />
              <span>{formatDateTime(item.timestamp ?? item.created_at)}</span>
            </div>
          </div>
        </div>
      );
    })}
  </div>
);

export default TeamActivityTimeline;
